import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import PhraseContext from '../../phrase/PhraseContextInterface';
import { useContext } from 'react';
import { Typography } from '@helsingborg-stad/municipio-react-ui';
function SignUpForm({ volunteer, onSubmit = () => { }, children }) {
    const { phrase } = useContext(PhraseContext);
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ style: {
                    position: 'absolute',
                    top: '32px',
                    left: '24px',
                } }, { children: _jsxs(Typography, Object.assign({ variant: "meta" }, { children: [phrase('logged_in_as', 'Logged in as') + ': ', _jsxs("b", { children: [volunteer.firstName, " ", volunteer.lastName] })] })) })), _jsx("div", { children: children })] }));
}
export default SignUpForm;
